/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLMSCapabilities } from './BaseLMSCapabilities';
const LMSCapabilitiesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'testStudentName',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecString)),
        'test_student_name',
    ],
]), BaseLMSCapabilities);
export class LMSCapabilities extends BaseLMSCapabilities {
    static decode(input) {
        return LMSCapabilitiesParser.decode(input).map(res => new LMSCapabilities(res));
    }
    static unsafeDecode(input) {
        return LMSCapabilities.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LMSCapabilitiesParser.encode(data);
    }
    static schema() {
        return LMSCapabilitiesParser.schema();
    }
}
